export const CARGAR_MASTER="cargar_master";
export const CARGAR_MASTER_CONFIGS="cargar_master_configs";
export const CARGAR_MARKETPLACE_CONFIGS="cargar_marketplace_configs";
export const CARGANDO="masters_cargando";
export const ERROR="master_error";
